import { logger, setDisableScrolling } from '@/common/utils/common'
import _ from 'lodash'
import constant from '@/common/resources/constant'
import { changeProfileProc } from '@/common/utils/login'
import { parseUrl } from 'query-string'
import { PLAYER_EXPIRED_CREDENTIAL_EVENT, PLAYER_PLAY_EVENT, PLAYER_UPDATE_EVENT } from '@/common/player.const'
import { UPDATE_CONTENT_INFO_EVENT } from '@/common/resources/const'
import utils from '@/common/util/utils'
import { requestCPToken } from '@/common/utils/apollo.interface'

/**
 * ApolloPlayerDetail에 mixins 되는 플레이어 공통 객체
 * delegate를 통한 플레이어와의 통신 후처리
 * 그외 공통 기능
 * TODO :: 비사용로직 정리 필요
 */
export default {
  data () {
    return {
      isPlay: false,
      isPlayAd: false,
      shareLayout: false,
      downloadLayout: false,
      downloadContentId: '',
      downloadContentType: '',
      ogTitle: '',
      ogUrl: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search,
      ogDescription: '',
      ogImage: ''
    }
  },
  methods: {
    setMetaData ({ ogTitle, ogDescription, ogImage }) {
      this.ogTitle = ogTitle
      this.ogDescription = ogDescription
      this.ogImage = ogImage
    },
    replaceState (url) {
      this.$router.replace(url)
    },
    // 공유 레이어 팝업 닫기
    openShareLayout () {
      this.shareLayout = true
      setDisableScrolling(true) // 윈도우 스크롤 사용
    },
    closeShareLayout () {
      this.shareLayout = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    delegateGlobalFunctions () {
      let self = this
      // 회원 가입 페이지 이동
      window.gotoSignup = function () {
        window.location.href = constant.URL_MEMBER_SIGNUP
      }
      // 실명 인증 페이지 이동
      window.gotoAuthorization = function () {
        window.location.href = constant.URL_MEMBER_ME
      }
      // 광고 재생 여부 변경
      window.isPlayAd = function (isPlayAd) {
        self.isPlayAd = isPlayAd
      }
      // 프로필 정보가 바꼈을 때 리로그인 처리
      window.reLoginProc = function () {
        changeProfileProc({ profileId: 0 }).then(() => {
          window.location.reload()
        })
      }
      // 공유 레이어 팝업
      window.showShareLayout = function () {
        self.shareLayout = true
        setDisableScrolling(true) // 윈도우 스크롤 방지
      }
    },
    delegatePlayEvent () {
      this.$events.$on(PLAYER_PLAY_EVENT, function (info) {
        this.isPlay = true
      }.bind(this))
    },
    delegateUpdateEvent () {
      // TODO:: 동작 확인 필요
      this.$events.$on(PLAYER_UPDATE_EVENT, (info) => {
        const value = _.assign(info, { resetPage: false })
        let current = location.pathname.replace('/apollo/player/', '')
        let destination = _.get(value, 'type', '')
        const isVod = type => (type === 'vod' || type === 'onairvod')
        destination = isVod(destination) ? 'vod' : destination
        logger('red')(current)
        logger('red')(destination)

        let url = null
        let contentID = _.get(value, 'contentID', '')
        if (destination === 'vod') {
          let programID = _.get(value, 'programID', '')
          url = '/apollo/player/vod?contentid=' + contentID + '&programid=' + programID
        } else if (destination === 'movie') {
          url = '/apollo/player/movie?movieid=' + contentID
        } else if (destination === 'live') {
          url = '/apollo/player/live?channelid=' + contentID
        }
        // INFO: CLIP 삭제
        // else if (destination === 'clip') {
        //   url = '/player/clip.html?clipid=' + value.contentID
        // }
        // this.$router.push(url)
        location.href = window.location.protocol + '//' + window.location.hostname + url
      })
    },
    delegateExpiredCredential () {
      this.$events.$on(PLAYER_EXPIRED_CREDENTIAL_EVENT, async function (info) {
        requestCPToken()
      }.bind(this))
    }
  },
  created () {
    this.delegateGlobalFunctions()
    this.delegateUpdateEvent()
    this.delegatePlayEvent()
    this.delegateExpiredCredential()
  },
  beforeDestroy () {
    this.$off(PLAYER_UPDATE_EVENT)
    this.$off(UPDATE_CONTENT_INFO_EVENT)
    this.$off(PLAYER_PLAY_EVENT)
    this.$off(PLAYER_EXPIRED_CREDENTIAL_EVENT)

  }
}
